import {
  ApiBlobGetRequest,
  ApiGetRequest,
  ApiPostRequest,
  //   ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Invoice Pembelian',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Invoice Pembelian',
        href: '/adm/fin/pembelian/invoice',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_beli',
    sortDesc: true,
    fields_choose: [
      {
        key: 'code_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Pemasok',
      },
      {
        key: 'tgl_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'down_payment',
        label: 'DP',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
    ],
    fields: [
      {
        key: 'code_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Pemasok',
      },
      {
        key: 'tgl_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_buy',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'down_payment',
        label: 'DP',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
      {
        key: 'status_beli',
        label: 'Status',
      },
      {
        key: 'payment',
        label: 'Bayar',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    journal: false,
    row_item: {
      description: '',
      id_product: '',
      item_acc: '',
      item_order: '',
      item_send: '',
      id_satuan: '',
      item_price: '',
      item_disc: '',
      item_disc_nominal: '',
      item_acc_disc: '',
      item_id_pajak: '',
      item_acc_tax: '',
      item_tax: '',
      item_persentase: 0,
      item_total: 0,
    },
    form: {
      code_beli: '',
      id_supplier: '',
      supplier_code: '',
      supplier_name: '',
      tgl_beli: '',
      tgl_faktur: '',
      tgl_kirim: '',
      id_currency: '',
      id_department: '',
      id_gudang: '',
      type_buy: 0,
      type_payment: 0,
      remark: '',
      term_payment: '',
      memo: '',
      other_cost: '',
      acc_other_cost: '',
      acc_other_cost_code: '',
      acc_other_cost_name: '',
      total_pajak: '',
      total_invoice: '',
      down_payment: '',
      id_um_beli: '',
      total_payment: '',
      acc_total_payment: '',
      acc_total_payment_code: '',
      acc_total_payment_name: '',
      status_beli: '',
      id_journal: '',
      id_sales: '',
      sales_code: '',
      sales_name: '',
      items: [
        {
          description: '',
          id_product: '',
          item_acc: '',
          item_order: '',
          item_send: '',
          id_satuan: '',
          item_price: '',
          item_disc: '',
          item_disc_nominal: '',
          item_acc_disc: '',
          item_id_pajak: '',
          item_acc_tax: '',
          item_tax: '',
          item_persentase: 0,
          item_total: 0,
        },
      ],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeInvPembelian(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        code_beli: '',
        id_supplier: '',
        supplier_code: '',
        supplier_name: '',
        tgl_beli: '',
        tgl_faktur: '',
        tgl_kirim: '',
        id_currency: '',
        id_department: '',
        id_gudang: '',
        type_buy: 0,
        type_payment: 0,
        remark: '',
        term_payment: '',
        memo: '',
        other_cost: '',
        acc_other_cost: '',
        acc_other_cost_code: '',
        acc_other_cost_name: '',
        total_pajak: '',
        total_invoice: '',
        down_payment: '',
        id_um_beli: '',
        total_payment: '',
        acc_total_payment: '',
        acc_total_payment_code: '',
        acc_total_payment_name: '',
        status_beli: '',
        id_journal: '',
        id_sales: '',
        sales_code: '',
        sales_name: '',
        id_type_payment: '',
        items: [
          {
            description: '',
            id_product: '',
            item_acc: '',
            item_order: '',
            item_send: '',
            id_satuan: '',
            item_price: '',
            item_disc: '',
            item_disc_nominal: '',
            item_acc_disc: '',
            item_id_pajak: '',
            item_acc_tax: '',
            item_tax: '',
            item_persentase: 0,
            item_total: 0,
          },
        ],
      },
    });
  },
};

export const actions = {
  async getLastNoFaktur({ commit, state }) {
    commit('changeInvPembelian', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/pembelian/last-id`);
    commit('changeInvPembelian', {
      form: {
        ...data.form,
        code_beli: result.data.object,
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListPembelian({ commit, state }, payload = {}) {
    commit('changeInvPembelian', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      for_retur: data.for_retur ? data.for_retur : 0,
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (data.type_buy === 1 || data.type_buy === 0) {
      params.type_buy = data.type_buy;
    }

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`logistic/pembelian`, params);
      commit('changeInvPembelian', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_invoice_pembelian.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`logistic/pembelian`, params);
      commit('changeInvPembelian', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getJournalInvoice({ commit }, payload = null) {
    commit('changeInvPembelian', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `logistic/pembelian/${payload.id}/journal`
    );
    commit('changeInvPembelian', {
      loading: false,
    });

    if (!result.error) {
      commit('changeInvPembelian', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailOrderBeli({ commit }, payload = null) {
    commit('changeInvPembelian', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `logistic/pembelian/order-beli/${payload.id}`
    );
    commit('changeInvPembelian', {
      loading: false,
    });

    if (!result.error) {
      commit('changeInvPembelian', {
        form: {
          ...data.form,
          ...result.data.object,
          type_buy: +result.data.object.type_buy,
          items: result.data.object
            ? result.data.object.items
            : [data.row_item],
        },
      });
    }

    return !result.error ? true : false;
  },

  async getDetailPembelian({ commit, state }, payload = null) {
    commit('changeInvPembelian', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/pembelian/${payload.id}`);
    commit('changeInvPembelian', {
      loading: false,
    });

    if (!result.error) {
      commit('changeInvPembelian', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          tgl_kirim: result.data.object.tgl_kirim
            ? moment(result.data.object.tgl_kirim).format('DD/MM/YYYY')
            : null,
          tgl_faktur: result.data.object
            ? moment(result.data.object.tgl_faktur).format('DD/MM/YYYY')
            : '',
          type_buy:
            result.data.object.type_buy &&
            parseInt(result.data.object.type_buy) > 0
              ? 1
              : 0,
          type_payment:
            result.data.object.type_payment &&
            parseInt(result.data.object.type_payment) > 0
              ? 1
              : 0,
        },
      });
    }

    return !result.error ? true : false;
  },

  async approveDataInvoice({ commit, dispatch }, payload = null) {
    commit('changeInvPembelian', {
      loading: true,
    });

    let result = await ApiPostRequest('logistic/pembelian/approve', payload);

    commit('changeInvPembelian', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async createPembelian({ commit, state, dispatch }) {
    commit('changeInvPembelian', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('logistic/pembelian', data.form);

    commit('changeInvPembelian', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updatePembelian({ commit, state, dispatch }, payload = null) {
    commit('changeInvPembelian', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `logistic/pembelian/${payload.id}`,
      data.form
    );

    commit('changeInvPembelian', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
